import cn from 'classnames';
import { createUrlWithSourceQueryParams } from '@crehana/utils';
import { jsx as _jsx } from "react/jsx-runtime";
var UserTag = function UserTag(_ref) {
  var offsetKey = _ref.offsetKey,
    decoratedText = _ref.decoratedText,
    isDark = _ref.isDark,
    _ref$userTagLink = _ref.userTagLink,
    userTagLink = _ref$userTagLink === void 0 ? {
      baseUrl: 'https://www.crehana.com/users/',
      openInNewWindow: true,
      className: "".concat(cn('break-all truncate', isDark ? 'link-level4-dark' : 'link-level4'))
    } : _ref$userTagLink,
    amplitude = _ref.amplitude;
  var getUrl = function getUrl() {
    var userName = decoratedText.replace(/@/, '').replace(' ', '');
    var customUrl = "".concat(userTagLink.baseUrl).concat(userName);
    return amplitude ? createUrlWithSourceQueryParams({
      url: customUrl,
      source: (amplitude === null || amplitude === void 0 ? void 0 : amplitude.source) || '',
      sourceDetail: amplitude === null || amplitude === void 0 ? void 0 : amplitude.sourceDetail
    }) : customUrl;
  };
  return /*#__PURE__*/_jsx("a", {
    "data-offset-key": offsetKey,
    className: userTagLink.className,
    href: getUrl(),
    target: userTagLink.openInNewWindow ? '_blank' : undefined,
    rel: "noopener noreferrer",
    children: decoratedText
  });
};
export default UserTag;